const api_prefix = process.env.REACT_APP_API_PREFIX


export default {
    api_prefix
}
